import React, { useContext } from 'react';
import { Field } from 'formik';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { appendValidationClassNames } from './utils';
import { FormContext } from './FormContext';

const DatePickerField = React.forwardRef((props, ref) => {
  const context = useContext(FormContext);
  const { disabled, readOnly } = context ? context : {};
  const extProps = { disabled, readOnly, ...props };

  return (
    <Field
      {...props}
      ref={ref}
      render={({ field, form: { touched, errors, setFieldValue } }) => {
        const { value, ...fieldRest } = field;

        const dateFormat = props.dateFormat ? props.dateFormat : 'MM/dd/yyyy';
        const placeholderText = props.placeholderText
          ? props.placeholderText
          : 'MM/dd/yyyy';

        const classes = appendValidationClassNames(
          props.className,
          touched,
          errors,
          field.name
        );

        const isDisabled = String(extProps.disabled).toLowerCase() === 'true';
        const isClearable = !isDisabled;
        
        return (
          <DatePicker
            {...fieldRest}
            {...extProps}
            dateFormat={dateFormat}
            placeholderText={placeholderText}
            selected={value ? value : null}
            isClearable={isClearable}
            strictParsing
            onChange={e => {
              if (e === '') e = null;
              setFieldValue(props.name, e);
            }}
            className={classes}
          />
        );
      }}
    />
  );
});

DatePickerField.displayName = 'DatePickerField';
export default DatePickerField;
